export default "* Naturmaterialer\n* Farve\n* Maling";